export default __webpack_public_path__ + "static/media/gestao-papel-comercial.bacc7225.svg";